import { useAppSelector } from "../redux/hooks";

const EMPTY_ROLES: string[] = [];

export function useHasAnyRole(roles: string[]): boolean {
  const userRoles = useAppSelector((state) => state.auth.user?.roles ?? EMPTY_ROLES);
  return roles.some((role) => userRoles.includes(role));
}